import { FC } from 'react';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';

export const BreadcrumbsBackButton: FC<{ handleBackClick: () => void }> = ({ handleBackClick }) => {
  return (
    <button
      data-cy="breadcrumbs-back-button"
      onClick={handleBackClick}
      className="flex items-center w-[26px] h-[26px] p-1 rounded border-[1px] border-solid border-neutral-200 hover:bg-zinc-50"
    >
      <Icon icon={IconsMap.ARROW_LEFT_BACK} className="w-4 h-4 text-neutral-500" />
    </button>
  );
};
